import React from 'react';
import { Card, CardContent } from '../ui/card';
import { Button } from '../ui/button';
import { Badge } from '../ui/badge';
import { Mail, Phone, Calendar, MessageSquare, TrendingUp } from 'lucide-react';

const STATUS_COLORS = {
  new: 'bg-blue-100 text-blue-700',
  contacted: 'bg-yellow-100 text-yellow-700',
  closed: 'bg-green-100 text-green-700',
};

export const InquiryCard = ({ inquiry, onUpdateStatus }) => (
  <Card className="hover:shadow-lg transition-shadow" data-testid="admin-inquiry-card">
    <CardContent className="p-6">
      <div className="flex flex-col md:flex-row md:items-start md:justify-between gap-4">
        <div className="flex-1 space-y-3">
          <div className="flex items-center gap-3">
            <h3 className="text-lg font-bold text-gray-900">{inquiry.name}</h3>
            <Badge className={STATUS_COLORS[inquiry.status] || 'bg-gray-100 text-gray-700'}>
              {inquiry.status}
            </Badge>
          </div>

          <div className="grid md:grid-cols-2 gap-3 text-sm">
            <div className="flex items-center gap-2 text-gray-600">
              <Mail className="w-4 h-4" />
              {inquiry.email ? (
                <a href={`mailto:${inquiry.email}`} className="hover:text-cyan-600">
                  {inquiry.email}
                </a>
              ) : (
                <span className="text-gray-400 italic">No email (popup lead)</span>
              )}
            </div>
            <div className="flex items-center gap-2 text-gray-600">
              <Phone className="w-4 h-4" />
              <a href={`tel:${inquiry.phone}`} className="hover:text-cyan-600">
                {inquiry.phone}
              </a>
            </div>
            <div className="flex items-center gap-2 text-gray-600">
              <TrendingUp className="w-4 h-4" />
              <span>{inquiry.service}</span>
            </div>
            <div className="flex items-center gap-2 text-gray-600">
              <Calendar className="w-4 h-4" />
              <span>{new Date(inquiry.created_at).toLocaleDateString()}</span>
            </div>
          </div>

          {inquiry.message && (
            <div className="flex items-start gap-2 text-sm text-gray-700 bg-gray-50 p-3 rounded-lg">
              <MessageSquare className="w-4 h-4 mt-0.5 flex-shrink-0" />
              <p>{inquiry.message}</p>
            </div>
          )}
        </div>

        <div className="flex md:flex-col gap-2">
          {inquiry.status !== 'contacted' && (
            <Button
              size="sm"
              variant="outline"
              onClick={() => onUpdateStatus(inquiry.id, 'contacted')}
              className="text-yellow-600 border-yellow-600 hover:bg-yellow-50"
              data-testid="mark-contacted-btn"
            >
              Mark Contacted
            </Button>
          )}
          {inquiry.status !== 'closed' && (
            <Button
              size="sm"
              variant="outline"
              onClick={() => onUpdateStatus(inquiry.id, 'closed')}
              className="text-green-600 border-green-600 hover:bg-green-50"
              data-testid="mark-closed-btn"
            >
              Mark Closed
            </Button>
          )}
        </div>
      </div>
    </CardContent>
  </Card>
);
